import { render, staticRenderFns } from "./FormInbox.vue?vue&type=template&id=5ba87cb1&scoped=true"
import script from "./FormInbox.vue?vue&type=script&lang=js"
export * from "./FormInbox.vue?vue&type=script&lang=js"
import style0 from "./FormInbox.vue?vue&type=style&index=0&id=5ba87cb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba87cb1",
  null
  
)

export default component.exports